import { autoinject } from "aurelia-framework";
import momentTz from "moment-timezone";

import { IRequestHandler } from "../../interfaces/i-handlers";

@autoinject()
export class TimeZoneHandler implements IRequestHandler {
    public async handle(request: Request): Promise<void> {
        request.headers.set("X-Time-Zone", momentTz.tz.guess());
    }
}
